export const DETAILS_LEAD = [
  { label: "Period", value: "March to October" },
  { label: "Duration", value: "2 - 6 months" },
  { label: "Location", value: "Alnarp, Lomma, Sweden" },
] as const;

export const DETAILS_REST = [
  {
    label: "Work pace",
    value:
      "Four days per week on the farm with the team. The fifth day is for office tasks from home, personal projects, or internship-related work — depending on season and your interests.",
  },
  { label: "Accommodation", value: "Not provided" },
  {
    label: "Language",
    value:
      "English is the main language. Swedish is also spoken but is not required.",
  },
  {
    label: "Food",
    value:
      "During summer, lunch is prepared together using fresh vegetables from the farm. Cooking duties are shared among team members and interns, and all ingredients are provided. For the rest of the year, fika is offered during work sessions, but you bring your own lunch.",
  },
  { label: "Compensation", value: "Non-financial" },
  {
    label: "Certificate",
    value:
      "A signed certificate is provided at the end of the internship program.",
  },
] as const;
